(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name message.service:alertManagerService
	 *
	 * @description
	 *
	 */
	angular.module('message').service('AlertManagerService',
			AlertManagerService);

	function AlertManagerService(AlertRequestFactory, RemoteService,
			crewScheduleService, CommonMasterData) {

		var self = this;

		var model = {
			alertSearchCriteria : AlertRequestFactory.getAlertSearchRequest(),
			alertsToMarkAsInform : AlertRequestFactory.getMarkAsInformRequest(),
			alertList : [],
      alertCreatedByList : null,
      templateCodeList : null,
			crewDetailsCopy : [],
			sendMsgMaxCharCount : 0,
			sendSms : AlertRequestFactory.getSMSSendRequest(),
			editSms : AlertRequestFactory.getNewSMS(),
			crewTypes : [],
			crewList : []
		};

		self.getSMSSendRequest = function(){
			model.sendSms = AlertRequestFactory.getSMSSendRequest();
			return model.sendSms;
		};

    self.getAlertCreatedByList = function (successFn, errorFn) {
      if (model.alertCreatedByList === null) {
        RemoteService.getAlertCreatedByList().then(
          function (response) {
            model.alertCreatedByList = response.createdByList;
            successFn(model.alertCreatedByList);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      } else {
        successFn(model.alertCreatedByList);
      }

      return model.alertCreatedByList;
    };

    self.getAlertTemplateCodeList = function (successFn, errorFn) {
      if (model.templateCodeList === null) {
        RemoteService.getAlertTemplateCodeList().then(
          function (response) {
            model.templateCodeList = response.templateCodeList;
            successFn(model.templateCodeList);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      } else {
        successFn(model.templateCodeList);
      }

      return model.templateCodeList;
    };

		// setter and getter of search criteria
		self.setAlertSearchCriteria = function(searchCriteria) {
			model.alertSearchCriteria = AlertRequestFactory
					.getFormattedAlertSearchRequest(searchCriteria);
		};
		self.getAlertSearchCriteria = function() {
			return model.alertSearchCriteria;
		};

		// settern and gettern of the marked as informed alert
		self.setMarkAsInformedAlerts = function(selectedAlerts) {
			model.alertsToMarkAsInform = AlertRequestFactory
					.getMarkAsInformRequest();
			if(!!selectedAlerts && selectedAlerts.length>0){
				for(var i=0;i<selectedAlerts.length;i++){
					var markAsInformAlert = AlertRequestFactory.getFormatedMarkAsInformAlertDTO(selectedAlerts[i]);
					model.alertsToMarkAsInform.alertCollection.push(markAsInformAlert);
				}
			}else{
				model.alertsToMarkAsInform.alertCollection = [];
			}
		};

		self.getMarkAsInformedAlert = function() {
			return model.alertToMarkAsInform;
		};

		// get the smsMaxaxCharacterCount
		self.setSendMsgMaxCharCount = function(maxCount) {
			model.sendMsgMaxCharCount = maxCount;
		}

		// get search results
		self.getAlerts = function(successFn, errorFn) {
			// TODO call to RemoteService load alerts by sending
			// model.alertSearchCriteria
			RemoteService.searchAlerts(model.alertSearchCriteria).then(
					function(response) {
						if (response.success && !!response.alerts) {
							model.alertList = AlertRequestFactory
									.getFormattedAlerts(response.alerts);
							successFn(model.alertList,response.startPosition);
						}
					}, function(error) {
						errorFn(error.msg[0]);
					});
		};

		//marked As Informed
		self.setMarkAsInformed = function(successFn, errorFn){
			RemoteService.markAsInform(model.alertsToMarkAsInform).then(function(response) {
				successFn(response);
			}, function(error) {
				errorFn(error)
			});
		};

		// setter and getter of edit SMS
		self.setSMSToEdit = function(selectedAlert) {
			model.editSms = AlertRequestFactory.getNewSMS(selectedAlert);
			// set values
			if(selectedAlert.category == "Crew Alerts"){
			  getCrewTypes(selectedAlert);
        getCrewListByCrewType(selectedAlert);
			}else if(selectedAlert.category == "System Alerts"){
			  var crewProfiles = [];
        for (var key in selectedAlert.crewProfileCol) {
          if (selectedAlert.crewProfileCol.hasOwnProperty(key)) {
            angular.forEach(selectedAlert.crewProfileCol[key], function (crewProfile) {
              crewProfile.crewName = crewProfile.firstName + " " + crewProfile.lastName;
              crewProfiles.push(crewProfile);
            });
          }
        }
        model.editSms.crew = crewProfiles;
			}
			model.editSms.content = selectedAlert.msgContent;
			model.editSms.hasConfirmation = true;
			model.editSms.confirmationDuration = 0;
			model.editSms.category = selectedAlert.category;
			return model.editSms;
		};

		function getCrewListByCrewType(params) {
			var param = {};
			param.active = true;
			param.crewType = params.crewTypeCode;
			CommonMasterData.loadCrewList(param, function(response) {
				model.crewList = crewScheduleService
						.adaptCrewList(response);
				model.editSms.crew = _.find(model.crewList, {
					displayName : params.crewName
				});
			}, function() {
				console.log('Crew list retrieval error');
			});
		}
		;

		function getCrewTypes(param) {
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				model.crewTypes = crewTypes;
				model.editSms.crewTypeCode = _.find(model.crewTypes, {
					crewTypeCode : param.crewTypeCode
				});
			}, function() {
				console.log('Crew types retrieval error');
			});
		}
		;

		self.getSMSToEdit = function() {
			model.editSms = AlertRequestFactory.getNewSMS(selectedAlert);
			return model.editSms;
		};

		// setter and getter of sent SMS
		self.setSMSToSend = function(editedSMS) {
			model.editSms = AlertRequestFactory.getFormattedSMSSendRequest(editedSMS);
			return model.editSms;
		};
		self.getSMSToSend = function() {
			model.editSms = AlertRequestFactory.getNewSMS();
			return model.editSms;
		};

		self.setCrewDetailCopy = function(crewDetails) {
			model.crewDetailsCopy = crewDetails;
		};

		self.getCrewDetailsByCrewTypeCode = function(crewTypeCode) {
			var crewDetailList = [];
			_.each(model.crewDetailsCopy, function(crewDetail) {
				if (crewDetail.crewTypeCode === crewTypeCode) {
					crewDetailList.push(crewDetail);
				}
			});
			return crewDetailList;
		};

		self.getNewAlert = function() {
			return AlertRequestFactory.getAlertForEditor();
		};

		self.setAlertForEdit = function(alert) {
			var editorAlert = AlertRequestFactory.getAlertForEditor();
			editorAlert.alertId = alert.alertId;
			editorAlert.version = alert.version;
			editorAlert.category = alert.category;
			editorAlert.crewTypeCode = _.find(getCrewTypes(), {
				"crewTypeCode" : alert.crewTypeCode
			});
			vm.crewList = loadCrewList(alert.crewTypeCode);
			editorAlert.crewName = _.find(getCrewListByCrewType(crewTypeCode),
					{
						"displayName" : alert.crewName
					});
			editorAlert.blockOrEvent = alert.blockOrEvent;
			editorAlert.msgContent = alert.msgContent;
			editorAlert.isHandled = alert.isHandled;
			editorAlert.crewProfileId = alert.crewProfileId;
			editorAlert.viewedDate = alert.viewedDate;
			editorAlert.viewedTime = alert.viewedTime;
			editorAlert.affectedDutyDate = alert.affectedDutyDate;
			editorAlert.handledBy = alert.affectedDutyDate;
			editorAlert.handledDate = alert.handledDate;
			editorAlert.handledTime = alert.handledTime;
			editorAlert.createdBy = alert.createdBy;
			editorAlert.createdDate = alert.createdDate;
			editorAlert.createdTime = alert.createdTime;
			return editorAlert;
		};

		self.getSendMsgMaxCharacterCount = function(successFn) {
			return RemoteService
					.getSendMsgMaxCharacterCount()
					.then(
							function(response) {
								if (response.success) {
									successFn(response.appParamValueDTO);
									self
											.setSendMsgMaxCharCount(response.appParamValueDTO);
								}
							}, function(error) {
								MessageService.error(error)
							});
		};

		self.getSendingSMS = function() {
			return AlertRequestFactory.sendSmsRequest();
		};

		/**
		 * Send Sms helper function
		 *
		 * @param smsPrams
		 * @param successFn
		 * @param errorFn
		 */
		self.sendSMS = function(smsPrams, successFn, errorFn) {
			RemoteService.sendSMS(smsPrams).then(function(response) {
				successFn(response);
			}, function(error) {
				errorFn(error)
			});
		};

		self.setSMSRequestInMultiSelect = function(selectedAlerts){
			model.sendSms = AlertRequestFactory.setSMSRequestForMultipleAlerts(selectedAlerts);
			return model.sendSms;
		};
	}
})();
